<template>
	<router-link
		v-if="linkType !== 'custom'"
		:to="linkUrl"
		:class="[classname, linkType]"
		:target="target"
		:title="title"
		:aria-label="title"
		:rel="target === '_blank' ? 'noopener' : ''"
		ref="link"
		:exact="exact"
	>
		<slot></slot>
	</router-link>

	<a
		v-else
		:href="linkUrl"
		:class="[classname, linkType]"
		:target="target"
		:aria-label="title"
		:rel="target === '_blank' ? 'noopener' : ''"
		:title="title"
		ref="link"
	>
		<slot></slot>
	</a>
</template>

<script>
export default {
	name: 'wp-link',
	props: ['url', 'title', 'classname', 'target', 'type', 'id'],
	mounted: function () {},
	data() {
		return {
			homeUrl: window.WPVUE.home,
		}
	},
	watch: {},
	computed: {
		exact() {
			if (this.linkUrl === '/') return true
			return false
		},

		linkUrl() {
			if (this.url === '/') return this.url
			let url = this.url.replace(/\/$/, '')
			const homeUrl = this.homeUrl.replace(/\/$/, '')
			//remove home url if link contain it

			if (url && url !== '' && url.includes(homeUrl)) {
				url = url.replace(homeUrl, '')
			}
			//console.log('b', url)
			//console.log(homeUrl)
			//console.log(url)
			return url
		},
		linkType() {
			const url = this.linkUrl
			const pattern = /^((http|https):\/\/)/
			if (!url) {
				console.warn('LINK REQUIRE URL, get: ', url)
				return false
			}
			if (this.type) {
				return this.type
			} else {
				if (url) {
					const emailsArray = url.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi)
					if (emailsArray != null && emailsArray.length) {
						return 'custom'
					} else if (url.includes('tel:') || url.includes('mailto:')) {
						return 'custom'
					}
				}

				if (pattern.test(url) || url.startsWith('#')) {
					return 'custom'
				}
			}

			return false
		},
	},
	methods: {},
}
</script>
